define(function(require) {
    'use strict';
    var AppConfig = require('config/application');
    var Backbone = require('backbone');

    return Backbone.Model.extend({
        urlRoot: AppConfig.host + '/rest/integrations/email/api',
    })
}); 
